import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Container } from "react-bootstrap";
import Navbar from "../../../components/user/navbar/Navbar";
import Footer from "../../../components/user/footer/Footer";
import AppContext from "../../../context/AppContext";
import axios from "axios";
import "../../../assets/css/user/payment/PaymentStatus.css";

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { baseUrl } = useContext(AppContext);
  const redirectTimeout = useRef(null);

  const [loading, setLoading] = useState(true);
  const [paymentData, setPaymentData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log(
      "ye useEffect ha payment success ka idhr hi create order wala code krna ha ",
    );
    const sessionId = searchParams.get("session_id");

    if (sessionId) {
      axios
        .get(
          `${baseUrl}/customer/orders/payment-success?session_id=${sessionId}`,
        )
        .then((res) => {
          if (res.data.success) {
            setPaymentData(res.data);
            setLoading(false);

            redirectTimeout.current = setTimeout(() => {
              navigate("/checkout");
            }, 5000);
          } else {
            setError(res.data.message || "Payment verify nahi ho saka.");
            setLoading(false);
          }
        })
        .catch((err) => {
          console.log(err);
          setError("Server se connect nahi ho saka.");
          setLoading(false);
        });
    } else {
      setError("Session ID nahi mila.");
      setLoading(false);
    }

    return () => {
      if (redirectTimeout.current) {
        clearTimeout(redirectTimeout.current);
      }
    };
  }, []);

  return (
    <div className="payment-status-page">
      <Navbar />
      <Container>
        {loading ? (
          <div className="payment-status-box">
            <div className="status-loader"></div>
            <p className="status-msg">Payment verify ho rahi hai...</p>
          </div>
        ) : error ? (
          <div className="payment-status-box cancel-box">
            <div className="status-icon cancel-icon">
              <svg
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="40"
                  cy="40"
                  r="38"
                  stroke="#ef4444"
                  strokeWidth="4"
                />
                <path
                  d="M28 28L52 52M52 28L28 52"
                  stroke="#ef4444"
                  strokeWidth="4"
                  strokeLinecap="round"
                />
              </svg>
            </div>
            <h1 className="status-title">Kuch Masla Hua</h1>
            <p className="status-msg">{error}</p>
            <div className="status-actions">
              <button
                className="btn-primary-action"
                onClick={() => navigate("/cart")}
              >
                Cart Par Jaein
              </button>
              {/* <button className="btn-secondary-action" onClick={() => navigate("/")}>
                Home Jaein
              </button> */}
            </div>
          </div>
        ) : (
          <div className="payment-status-box success-box">
            <div className="status-icon success-icon">
              <svg
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  cx="40"
                  cy="40"
                  r="38"
                  stroke="#22c55e"
                  strokeWidth="4"
                />
                <path
                  d="M24 41L35 52L56 30"
                  stroke="#22c55e"
                  strokeWidth="4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
            <h1 className="status-title">Payment Successful!</h1>
            <p className="status-msg">
              Shukriya! Aapka order Successfully place ho gaya hai.
            </p>
            {paymentData?.amount_total && (
              <p className="status-amount">
                Amount Paid:{" "}
                <strong>
                  {paymentData.currency}{" "}
                  {Number(paymentData.amount_total).toLocaleString()}
                </strong>
              </p>
            )}
            <p className="status-redirect">
              Aap 5 seconds mein Orders page par redirect honge...
            </p>
            <div className="status-actions">
              <button
                className="btn-primary-action"
                onClick={() => {
                  clearTimeout(redirectTimeout.current);
                  navigate("/checkout");
                }}
              >
                Continue Shopping
              </button>
              {/* <button className="btn-secondary-action" onClick={() => navigate("/")}>
                Home Jaein
              </button> */}
            </div>
          </div>
        )}
      </Container>
      <Footer />
    </div>
  );
}
